import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Map from "@material-ui/icons/Map";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

// const styles = {
//   firstCell: {
//     whiteSpace: "pre-wrap",
//   },
// };

const RegularMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultCenter={{ lat: props.lat, lng: props.lng }}
      defaultOptions={{ scrollwheel: false }}
      defaultZoom={8}
    >
      <Marker position={{ lat: props.lat, lng: props.lng }} />
    </GoogleMap>
  ))
);

const Mapa = ({ address, classes }) => {
  return (
    <GridContainer>
      <GridItem md={12} sm={12} xs={12}>
        <ECCard
          content={
            <RegularMap
              containerElement={
                <div style={{ borderRadius: "6px", height: "380px", overflow: "hidden" }} />
              }
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAn7KlMK6NEY1ysNzK_1oXPrudY2Vm8ibA"
              lat={address.latitude}
              lng={address.longitude}
              loadingElement={<div style={{ height: `100%` }} />}
              mapElement={<div style={{ height: `100%` }} />}
            />
          }
          icon={<Map />}
          title="Localização"
        />
      </GridItem>
    </GridContainer>
  );
};

Mapa.propTypes = {
  address: PropTypes.shape(PropTypes.shape({
    latitude: PropTypes.string.isRequired,
    longitude: PropTypes.string.isRequired,
  })),
  classes: PropTypes.object.isRequired,
};

export { Mapa as DREComponent };
export default withStyles({})(Mapa);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/Mapa.jsx